// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YdFP","fullView":"styles_fullView__ul-Gv"};